module.exports = __webpack_public_path__ + "images/3cddd72094e494bb68fc7120f851095c-europe_xpo.png";